export function getDeviceInfo() {
  if (typeof window === "undefined") {
    return {
      screenResolution: "",
      language: "",
      timezone: "",
      pageUrl: "",
    };
  }

  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const language = navigator.language || "";
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";

  const pageUrl = window.location.href;

  return { screenResolution, language, timezone, pageUrl };
}
